import AppLanguageSwitch from "./LanguageSwitch"
import Logout from "./Logout"
import { COLOR_DIVIDER, COLOR_WHITE } from "../constants"
import React from "react"
import Stack from "./Stack"
import Paper from "@material-ui/core/Paper"
import { Redirect, useLocation } from "react-router-dom"
import { useAppSelector } from "../store"
import { getAuthState } from "../users/store/selectors"
import { paths } from "../paths"
import { useUrlWithContext } from "../hooks/use-url-with-context"
import { usePageTitle } from "../hooks/use-page-title"
import StarbrixLogo from "../assets/icons/StarbrixLogo"
import { useTheme } from "@material-ui/core"

export const withInactiveRouteLayout = (Component: React.ComponentType<any>) => {
  const WithLayout = () => {
    const { user } = useAppSelector(getAuthState)
    const { createPathWithGivenContext } = useUrlWithContext()
    usePageTitle()
    const location = useLocation()
    const theme = useTheme()

    if (!user) return null
    if (user.isActive) {
      const nextPath = location.pathname === paths.accountVerification() ? paths.chooseIntroVideoType() : paths.home()
      const to = createPathWithGivenContext({ path: nextPath, mainContextId: user.id })
      return <Redirect to={to} />
    }

    return (
      <>
        <Paper
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
            background: "transparent",
          }}
          component={"main"}
        >
          <Paper
            variant="outlined"
            style={{
              maxWidth: 650,
              padding: 32,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: theme.spacing(4),
              }}
            >
              <StarbrixLogo />
            </div>

            <Stack>
              <Stack direction="row" packed alignItems="center">
                <AppLanguageSwitch />
                <Logout style={logoutStyle} />
              </Stack>
              <Component />
            </Stack>
          </Paper>
        </Paper>
      </>
    )
  }
  return WithLayout
}

const logoutStyle = {
  marginTop: 24,
  borderRadius: 4,
  border: `1px solid ${COLOR_DIVIDER}`,
  background: COLOR_WHITE,
}
